import { Control } from "react-hook-form";
import FormFileInput from "../../../../components/reusable-components/form/FormFileInput";
import FormTextField from "../../../../components/reusable-components/form/MuiFormInput";
import { useFieldRules } from "../../../../hooks/useFieldRules";
import { DomainCreateConstructor } from "../../models/DomainCreate";

type Props = {
  index: number;
  control: Control<DomainCreateConstructor>;
  disabled?: boolean;
};

const SectionInputs = ({ index, control, disabled }: Props) => {
  const rules = useFieldRules(); 

  const sectionPrefix = `sections.${index}` as const;

  return (
    <>
      <FormTextField
        name={`${sectionPrefix}.name`}
        label={`Section ${index + 1} Name`}
        control={control}
        rules={rules("Section Name").required().maxLength(254).get()}
        textFieldProps={{ disabled }}
      />

      <FormFileInput
        name={`${sectionPrefix}.category_file`}
        label="Category File"
        control={control}
        rules={rules("Category File").required().file(["csv", "txt"]).get()}
        buttonProps={{ disabled }}
      />

      <FormFileInput
        name={`${sectionPrefix}.content_file`}
        label="Content File"
        control={control}
        rules={rules("Content File").required().file(["csv", "txt"]).get()}
        buttonProps={{ disabled }}
      />
    </>
  );
};

export default SectionInputs;
